export default __webpack_public_path__ + "static/media/bannerkitrevmobile.78fd9d07.png";